import React, { Component } from 'react';
import './index.css';
import { Link } from 'react-router-dom';
import firebase from "../firebase/FirebaseProvider";
import { connect } from 'react-redux';;
import PropTypes from 'prop-types';
import Drawer from './drawer'

class Header extends Component {
  render() {
    const welcomeText = firebase.auth();
    return (
      <div className="header">
        <div className="logo">
          <Link to="/">
            <span className='logo-text'>bupples</span>
            <span className='alpha-release'>[ALPHA]</span>
          </Link>
        </div>
        <Drawer />
      </div>
    );
  }
}

Header.propTypes = {
  user: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);